// src/components/site-editor/SectionSelector.jsx
import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

/**
 * Section Selector - Dropdown to choose which section to edit
 *
 * Sections map to top-level keys in the JSON (hero, problem, benefits, etc.)
 */
const SectionSelector = ({ sections, selectedSection, onSelectSection }) => {
  // Format section name for display (convert camelCase to Title Case)
  const formatSectionName = (section) => {
    return section
      .replace(/([A-Z])/g, ' $1') // Add space before capital letters
      .replace(/^./, str => str.toUpperCase()) // Capitalize first letter
      .trim();
  };

  return (
    <div className="space-y-2">
      <label className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        Section
      </label>
      <Select value={selectedSection} onValueChange={onSelectSection}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select a section" />
        </SelectTrigger>
        <SelectContent>
          {sections.map((section) => (
            <SelectItem key={section} value={section}>
              {formatSectionName(section)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default SectionSelector;
